var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.service)?_c('div',[_c('memoryshare-stream',{attrs:{"slug":_vm.$route.params.slug,"options":_vm.options,"test":_vm.service.test}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }